import styled from '@emotion/styled'

import { ArcadeButton, Flex, spacing, Stack, Text } from '@cash-design-system/react'
import { BlockerActionConfirmationDialog } from '@cash-web/protos/squareup/franklin/blocker_action.pb'

import { MAX_ROW_BUTTON_TEXT_LENGTH } from '../FormBlocker/FormBlocker'

const ButtonContainer = styled(Flex)<{ shouldStackButtons: boolean }>`
  ${props => {
    if (props.shouldStackButtons) {
      return `flex-direction: column-reverse;
      gap: ${spacing.m};`
    } else {
      return 'flex-direction: row;'
    }
  }}
`

export const BlockerActionConfirmationDialogView = ({
  confirmation,
  onConfirm,
  onCancel,
}: {
  confirmation: BlockerActionConfirmationDialog
  onConfirm: () => void
  onCancel: () => void
}) => {
  const shouldStackButtons = Boolean(
    (confirmation.cancel_button_text && confirmation.cancel_button_text.length > MAX_ROW_BUTTON_TEXT_LENGTH) ||
      (confirmation.confirm_button_text && confirmation.confirm_button_text.length > MAX_ROW_BUTTON_TEXT_LENGTH)
  )

  return (
    <Stack space={spacing.xxl}>
      <Stack space={spacing.m}>
        <Text typography="numeralSmall" as="h2" color="textStandard">
          {confirmation.title}
        </Text>
        <Text typography="body" color="textSubtle">
          {confirmation.message}
        </Text>
      </Stack>
      <ButtonContainer gap={spacing.m} shouldStackButtons={shouldStackButtons}>
        <ArcadeButton size="cta" prominence="standard" onClick={onCancel}>
          {confirmation.cancel_button_text}
        </ArcadeButton>
        <ArcadeButton size="cta" prominence="prominent" onClick={onConfirm}>
          {confirmation.confirm_button_text}
        </ArcadeButton>
      </ButtonContainer>
    </Stack>
  )
}
